import { servicesData } from "@/mocks/homeData";
import AnimatedSection from "@/components/AnimatedSection";

export default function ServicesSection() {
  return (
    <section id="services" className="py-20 md:py-28 bg-background-50">
      <div className="container-astro">
        <AnimatedSection>
          <div className="text-center mb-14 md:mb-18">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 mb-5 font-heading tracking-tight">
              {servicesData.heading}
            </h2>
            <div className="w-16 h-1 bg-accent-500 rounded-full mx-auto" />
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {servicesData.items.map((service, i) => (
            <AnimatedSection key={service.title} delay={i * 100}>
              <div
                className={`group relative p-6 md:p-7 rounded-2xl border transition-all duration-400 card-lift h-full flex flex-col ${
                  service.featured
                    ? "bg-gradient-to-br from-primary-800 to-primary-900 border-primary-700/60 hover:border-accent-400/40 shadow-lg shadow-primary-900/10"
                    : "bg-background-100 border-background-200/60 hover:border-accent-300/30 hover:shadow-lg hover:shadow-accent-500/5"
                }`}
              >
                {service.featured && (
                  <div className="absolute -top-3 left-6 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-[10px] font-bold uppercase tracking-wider">
                    Primary
                  </div>
                )}

                <div
                  className={`w-13 h-13 flex items-center justify-center rounded-xl mb-5 transition-all duration-300 ${
                    service.featured
                      ? "bg-accent-500/15 text-accent-400 group-hover:bg-accent-500 group-hover:text-background-50"
                      : "bg-primary-50 text-primary-600 group-hover:bg-accent-500 group-hover:text-background-50"
                  }`}
                  style={{ width: "52px", height: "52px" }}
                >
                  <span className="w-6 h-6 flex items-center justify-center">
                    <i className={`${service.icon} text-xl`} />
                  </span>
                </div>

                <h3
                  className={`text-base md:text-lg font-bold mb-2.5 font-heading ${
                    service.featured ? "text-background-50" : "text-foreground-950"
                  }`}
                >
                  {service.title}
                </h3>
                <p
                  className={`text-sm leading-relaxed mb-5 flex-grow ${
                    service.featured ? "text-background-400" : "text-foreground-600"
                  }`}
                >
                  {service.desc}
                </p>

                <a
                  href="/services"
                  className={`inline-flex items-center gap-1.5 text-sm font-semibold transition-colors btn-arrow-hover group/link ${
                    service.featured
                      ? "text-accent-400 hover:text-accent-300"
                      : "text-accent-600 hover:text-accent-700"
                  }`}
                >
                  Explore Service
                  <i className="ri-arrow-right-line btn-arrow text-xs" />
                </a>
              </div>
            </AnimatedSection>
          ))}
        </div>

        <AnimatedSection delay={300}>
          <div className="text-center mt-12 md:mt-16">
            <a
              href="/services"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-gradient-to-r from-[#2563EB] via-[#7C3AED] to-[#F97316] text-white text-sm font-semibold rounded-xl hover:brightness-110 hover:-translate-y-0.5 transition-all duration-300 shadow-lg shadow-[#7C3AED]/25 whitespace-nowrap btn-arrow-hover group"
            >
              {servicesData.cta}
              <i className="ri-arrow-right-line btn-arrow" />
            </a>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}